import { createClient } from "@supabase/supabase-js";

import { isSupabaseConfigured, supabaseConfig } from "./supabase-config.js";

let browserClient = null;

export function getSupabaseBrowserClient() {
  if (!isSupabaseConfigured) {
    return null;
  }

  if (!browserClient) {
    browserClient = createClient(
      supabaseConfig.supabaseUrl,
      supabaseConfig.supabasePublishableKey,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: false,
          storageKey: "mincool.supabase.auth",
        },
      }
    );
  }

  return browserClient;
}

export function resetSupabaseBrowserClient() {
  browserClient = null;
}
